export default __webpack_public_path__ + "static/Tanya-4627e7adf6e07ee30e43d5f2c0b864a3c0599f5a6f50f7e363fe8406a057e64e.svg";